/**
 * Generates a unique positive integer (≤ 2^53−1) for use as a Janus room ID.
 *
 * F004 contract: the frontend must create an explicit room ID per call,
 * independent of the contact's phone number. The same value must be used in
 * both joinRoom() and all API payloads for the same call (POST + PATCH).
 *
 * Uses crypto-random bytes so concurrent calls are virtually guaranteed
 * to get distinct IDs. Never returns 0 (rejected by backend with HTTP 400).
 * The result fits in a JS safe integer (Number.MAX_SAFE_INTEGER = 2^53−1),
 * which is within the int64 range accepted by the gateway.
 */
function generateRoomId(): number {
  const arr = new Uint32Array(2);
  crypto.getRandomValues(arr);
  // Combine high part (capped to 21 bits via modulo) + 32-bit low part
  // → 53-bit safe integer. No bitwise ops: 2^21 = 2_097_152, 2^32 = 4_294_967_296.
  return (arr[0] % 2097152) * 4294967296 + arr[1] || 1;
}

export default generateRoomId;
